/**
 * @file SeoMarkupCard.tsx
 * @description Карточка «Разметка для поиска» во вкладке «Сайт → SEO →
 * Основное» (phase19.16, партия «SEO-техника», v0.19.65; SB47, SB146, SB132;
 * макет uiux-seo-tech.md §3.6). Только чтение: какую разметку schema.org
 * выводит платформа и показываются ли хлебные крошки на опубликованном
 * сайте («Сейчас: …» — по живой версии, а не по черновику: раздел SEO
 * говорит о живом сайте). Переключатель крошек — в конструкторе «Весь сайт →
 * Меню → Крошки» (право контента); без него — строка, кто меняет.
 */

import { Link } from "react-router";

import { SectionCard } from "../../ui/SectionCard";
import { useCurrentContext, useHasPermission } from "../../../auth/hooks";
import type { ShopSeoSettingsDto } from "../../../lib/api-site-seo";
import { builderLink } from "../../../lib/site-builder/selection";

export function SeoMarkupCard({ settings }: { settings: ShopSeoSettingsDto }) {
  const slug = useCurrentContext()?.shop?.slug ?? "";
  const canContent = useHasPermission("SHOP_MANAGE_CONTENT");
  const live = settings.navigation?.breadcrumbs;
  return (
    <SectionCard title="Разметка для поиска">
      <p className="type-body text-on-surface">Платформа сама выводит разметку schema.org: магазин, товары с ценой и отзывами, статьи и хлебные крошки.</p>
      <p className="type-body text-on-surface">
        Разметка крошек выводится там, где крошки видны.
        {live === undefined ? null : <> Сейчас: {live ? "показываются" : "скрыты"}.</>}
      </p>
      {canContent ? (
        <Link
          to={builderLink(slug, { panel: "menu", sub: "crumbs" })}
          className="type-body inline-flex min-h-12 items-center self-start font-medium text-primary hover:underline lg:min-h-11"
        >
          Настроить → Меню
        </Link>
      ) : (
        <p className="type-caption text-on-surface-variant">Меняет сотрудник с правом на контент сайта в конструкторе: «Весь сайт → Меню → Крошки».</p>
      )}
    </SectionCard>
  );
}
